// extracted by mini-css-extract-plugin
export default {"skillsBlock":"Skills_skillsBlock__e72SC","skillsContainer":"Skills_skillsContainer__+i-dz","title":"Skills_title__xjD5w","skills":"Skills_skills__jQHcB"};